import { useMutation } from "@apollo/client";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import { Button } from "../../../../components/ui";
import { CREATE_OFFERS as createOffersMutation } from "../../../../graphql/mutation/Offer";

const AddOffersBody = props => {
  const { closeModal, ids, listId, search, select } = props || {};
  const navigate = useNavigate();
  const [createOffers, { loading, reset }] = useMutation(
    createOffersMutation({ contact: {}, currency: {}, status: {} }),
    { refetchQueries: ["FetchOffersV2"] },
  );

  const formik = useFormik({
    initialValues: {
      ...(select === "all"
        ? { ...(listId ? { listId } : { search }) }
        : { artworkIds: ids }),
    },
    enableReinitialize: true,
    onSubmit: values => {
      createOffers({
        variables: {
          input: values,
        },
      }).then(resp => {
        const {
          data: { createOffers: { success } = {} },
        } = resp || {};
        if (success) {
          closeModal?.();
          reset?.();
          formik?.resetForm();
          navigate(`/offer/?status=selectListWorking`);
        }
      });
    },
  });

  return (
    <div className="flex w-full flex-col p-4 sm:p-6 lg:p-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
        <div className="flex flex-1 flex-col text-2xl font-bold">
          Create offers for selected Artworks?
        </div>
        <div className="flex flex-wrap gap-2 sm:gap-4">
          <Button
            action="default"
            className="sm:mr-4"
            label="Cancel"
            onClick={() => {
              closeModal();
              formik?.resetForm();
            }}
          />
          <Button
            label={loading ? "Creating" : "Create"}
            disabled={loading || !formik?.isValid}
            onClick={formik.submitForm}
          />
        </div>
      </div>
    </div>
  );
};

export default AddOffersBody;
